import React from 'react'
import { useData } from './context/DataContext'
import { WindowSizeProvider } from './context/WindowSizeContext'
import LandingPage from './landing/LandingPage'
import ContentRenderer from './content/ContentRenderer'

const ViewStateHandler: React.FC = () => {
  const { requestedVideo } = useData()
  return (
    <WindowSizeProvider>
      {requestedVideo == null && <LandingPage />}
      {requestedVideo != null && <ContentRenderer />}
    </WindowSizeProvider>
  )
}

export default ViewStateHandler
